import utils from "../../../utils/utils.js";

export default {
  async fetchSuperUserGnipArchiveDisconnections(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetGnipArchiveDisconnections?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setSuperUserGnipArchiveDisconnections", responseData.data);
  },
  async fetchSuperUserCollectActiveWorkspaces(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetCollectActiveWorkspaces`,
      "GET",
      null,
      null
    );

    context.commit("setSuperUserCollectActiveWorkspaces", response.data);
  },

  async postSuperUserGnipArchiveDisconnection(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateGnipArchiveDisconnection`,
      "POST",
      null,
      payload
    );
  },

  async deleteSuperUserGnipArchiveDisconnection(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteGnipArchiveDisconnection`,
      "POST",
      null,
      postData
    );
  },
};
